<template>
  <div>
    <b-modal
      :title="$t('modal.product_sheets.title_add')"
      :id="modalId"
      :ok-title="$t('modal.product_sheets.ok_button')"
      :cancel-title="$t('modal.general.cancel_button')"
      @show="resetForm"
      @ok="verifyForm">
      <b-form @submit.prevent="verifyForm">

        <!--SHEET NAME-->
        <b-form-group
          id="name-group"
          :label="$t('form.product_sheets.name')"
          label-for="name"
          :description="$t('form.product_sheets.name_help_text')"
        >
          <b-form-input
            id="name"
            v-model="productSheetForm.name"
            :placeholder="$t('form.product_sheets.name')"
          ></b-form-input>
        </b-form-group>

        <!--VAT RATE TYPE-->
        <b-form-group
          v-if="customerData.customerType && customerData.customerType.length > 1"
          id="vat-rate-type-group"
          :label="$t('form.customer.vat_rate_type')"
          :invalid-feedback="invalidVatRateType"
          :state="stateVatRateType"
          label-for="vat-rate-type"
        >
          <multiselect
            id="vat-rate-type"
            v-model="productSheetForm.vatRateType"
            :select-label="$t('multiselect.select_label')"
            :deselect-label="$t('multiselect.cannot_deselect')"
            :selected-label="$t('multiselect.selected_label')"
            :class="{ 'invalid-multiselect': $v.productSheetForm.vatRateType.$error }"
            :placeholder="$t('multiselect.placeholder', { field: $t('form.customer.vat_rate_type').toLowerCase() })"
            :options="vatRateTypes"
            track-by="type"
            :allow-empty="false"
            label="name">
          </multiselect>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

  import { mapState } from 'vuex'
  import {VAT_RATE_TYPES} from '@base/configs'
  import {required} from 'vuelidate/lib/validators'

  export const defaultProductSheetForm = {
    name: '',
    vatRateType: '',
  }

  export default {
    name: 'AddProductSheetModal',

    data () {
      return {
        productSheetForm: { ...defaultProductSheetForm },
        vatRateTypes: VAT_RATE_TYPES,
        loading: false,
      }
    },

    props: {
      modalId: {
        type: String,
        required: true
      }
    },

    validations: {
      productSheetForm: {
        vatRateType: {
          required
        },
      }
    },

    computed: {
      ...mapState(['customerData']),

      payloads () {
        return {
          name: this.productSheetForm.name || this.$t('form.product_sheets.default_name'),
          productType: this.productSheetForm.vatRateType ? this.productSheetForm.vatRateType.prefix : undefined,
        }
      },

      // VALIDATIONS
      stateVatRateType () {
        return (!this.$v.productSheetForm.vatRateType.$error)
      },
      invalidVatRateType () {
        if (this.$v.productSheetForm.vatRateType.$error) {
          if (!this.$v.productSheetForm.vatRateType.required)
            return this.$t('validation.required', { field: this.$t('form.customer.vat_rate_type') })
        }
        return null
      },

    },

    methods: {
      resetForm () {
        this.$v.$reset()
        this.productSheetForm = { ...defaultProductSheetForm }
      },

      verifyForm (bvModalEvt) {
        bvModalEvt.preventDefault()
        if (this.customerData.customerType && this.customerData.customerType.length > 1) {
          this.$v.$touch()
          if (this.$v.$invalid)
            return
        }
        this.addProductSheet()
      },
      addProductSheet () {
        if (this.loading)
          return
        this.loading = true
        this.loader = this.$loading.show(this.$_loaderOptions)
        this.$store.dispatch(this.$_actionTypes.CREATE_USER_PRODUCT_SHEET, this.payloads)
          .then((response) => {
            this.$emit('productSheetCreated', response)
            this.$nextTick(() => {
              this.$bvModal.hide(this.modalId)
            })
            this.$notify({
              group: 'app',
              type: 'success',
              title: this.$t('notifications.title.success'),
              text: this.$t('notifications.text.product_sheets.success_product_sheet_added')
            })
            this.$router.push({name: 'product-sheet-details', params: {productSheetId: response.id}})
          })
          .catch((error) => {
            this.$_notifyError(error.response, this)
          })
          .finally(() => {
            this.loader.hide()
            this.loading = false
          })
      },
    }
  }
</script>

<style>

</style>
